// Client-side guard that blocks link buttons pointing at NSFW / adult (18+) websites.
// This is a best-effort protective layer (a curated blocklist can never be exhaustive), matched
// against the URL's HOSTNAME only — so a creator's neutral host isn't blocked because of a word in
// the path. Pair the curated branded domains with a few highly distinctive keywords that are
// extremely unlikely to appear in a legitimate creator link (deliberately NOT "sex", which would
// false-positive on essex/sussex/middlesex, etc.).

export const NSFW_WARNING = 'URLs navigating to any NSFW and 18+ website is not allowed.'

const NSFW_DOMAINS = [
    'onlyfans.com', 'fansly.com', 'manyvids.com', 'fancentro.com', 'iwantclips.com',
    'clips4sale.com', 'avn.com', 'fapello.com', 'erome.com',
    'pornhub.com', 'xvideos.com', 'xnxx.com', 'xhamster.com', 'redtube.com', 'youporn.com',
    'youjizz.com', 'tube8.com', 'spankbang.com', 'brazzers.com', 'beeg.com', 'drtuber.com',
    'nuvid.com', 'sunporno.com', 'porntrex.com', 'porn300.com', 'thumbzilla.com', 'pornone.com',
    'txxx.com', 'upornia.com', 'gotporn.com', 'eporner.com', 'hclips.com', 'tnaflix.com',
    'motherless.com', 'porn.com', 'sex.com', 'xxx.com', 'redgifs.com',
    'chaturbate.com', 'stripchat.com', 'bongacams.com', 'myfreecams.com', 'cam4.com',
    'camsoda.com', 'livejasmin.com', 'jerkmate.com', 'cherry.tv',
    'adultfriendfinder.com', 'ashleymadison.com', 'fetlife.com',
    'rule34.xxx', 'e-hentai.org', 'nhentai.net', 'hentaihaven.xxx',
]

// Distinctive substrings that strongly signal adult content when found in the hostname.
const NSFW_KEYWORDS = ['porn', 'xxx', 'hentai', 'nsfw', 'camgirl', 'fapello', 'jerkmate']

/** Extract a normalised hostname from a possibly scheme-less URL; null if it can't be parsed. */
function hostnameOf(rawUrl) {
    const value = (rawUrl || '').trim()
    if (!value) return null
    try {
        const withScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(value) ? value : `https://${value}`
        return new URL(withScheme).hostname.toLowerCase().replace(/^www\./, '')
    } catch {
        return null
    }
}

/**
 * True if the URL points at a known/likely NSFW or adult (18+) website.
 * Matches on the hostname only (curated domains + their subdomains, plus distinctive keywords).
 */
export function isNsfwUrl(rawUrl) {
    const host = hostnameOf(rawUrl)
    if (!host) return false
    if (NSFW_DOMAINS.some((d) => host === d || host.endsWith(`.${d}`))) return true
    return NSFW_KEYWORDS.some((k) => host.includes(k))
}
